export default __webpack_public_path__ + "static/media/college_icon.6c248c1f.svg";